/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

export default {
  /** 目标内容 id */
  id: {
    type: String,
    default: '',
    required: true,
  },
  /** 渲染的标签 */
  tag: {
    type: String,
    default: 'div',
  },
};
